import { observer } from 'mobx-react';
import BulkEditInvitationsStore from '../../Store';
import ModalStore from '../../../../../../../Modal/Store';
import DeactivateConfirmation from './DeactivateConfirmation';
import Loader from '../../../../../../../Loader';
import DeactivateSuccess from './DeactivateSuccess';
import ReactivateSuccess from './ReactivateSuccess';
import { errorAlert } from '../../../../../../../../Notifications/Types';
import FlashMessage from '../../../../../../../FlashMessage';

interface Props {
  store: BulkEditInvitationsStore;
  modalStore: ModalStore;
}

function Form({ store, modalStore }: Props) {
  const { state } = store;
  switch (state.kind) {
    case 'confirming-deactivate':
      return <DeactivateConfirmation store={store} state={state} />;
    case 'deactivate-succeeded':
      return <DeactivateSuccess modalStore={modalStore} state={state} />;
    case 'reactivate-succeeded':
      return <ReactivateSuccess modalStore={modalStore} state={state} />;
    case 'waiting':
    case 'deactivating':
    case 'reactivating':
      return <Loader className="h-full py-40" />;
    case 'error':
      return <FlashMessage alert={errorAlert(state)} />;
  }
}

export default observer(Form);
